// removed by extract-text-webpack-plugin
module.exports = {"card-container":"card-container_RecommendCard","cardContainer":"card-container_RecommendCard","title":"title_RecommendCard","content":"content_RecommendCard","first":"first_RecommendCard","cover-box":"cover-box_RecommendCard","coverBox":"cover-box_RecommendCard","cover":"cover_RecommendCard","feed-title":"feed-title_RecommendCard","feedTitle":"feed-title_RecommendCard","enum-feed-box":"enum-feed-box_RecommendCard","enumFeedBox":"enum-feed-box_RecommendCard","enum-feed":"enum-feed_RecommendCard","enumFeed":"enum-feed_RecommendCard"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeTop/RecommendCard/RecommendCard.scss
// module id = 296
// module chunks = 0